import { render } from "./ComponentList.vue?vue&type=template&id=54d61510&scoped=true&ts=true"
import script from "./ComponentList.vue?vue&type=script&lang=ts"
export * from "./ComponentList.vue?vue&type=script&lang=ts"

import "./ComponentList.vue?vue&type=style&index=0&id=54d61510&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d61510"]])

export default __exports__